import { render, staticRenderFns } from "./BatchDetail.vue?vue&type=template&id=4aad7a2d&"
import script from "./BatchDetail.vue?vue&type=script&lang=js&"
export * from "./BatchDetail.vue?vue&type=script&lang=js&"
import style0 from "./BatchDetail.vue?vue&type=style&index=0&id=4aad7a2d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports